<template>
  <IconLucidePalette />
</template>
